// src/Pages/EvaluationLayout.jsx
import React from "react";
import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";

const EvaluationLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto">
        <Outlet /> {/* 👈 Affiche les sous-routes d'évaluation ici */}
      </div>
    </div>
  );
};

export default EvaluationLayout;
